import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock, Zap } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-20 md:py-32 bg-brand-charcoal text-white relative overflow-hidden" data-id="element-116">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-117">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border border-brand-gold" data-id="element-118"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border border-brand-gold" data-id="element-119"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-120">
        <FadeIn data-id="element-121">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-122">
            Es hora de dejar de trabajar como una empleada de bajo costo y
            empezar a facturar como una socia estratégica.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-123">
          <p className="text-xl text-brand-cream/80 mb-12" data-id="element-124">
            El acceso a la metodología que usan las VAs de alto nivel está a un
            clic de distancia.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-125">
          <div className="bg-white text-brand-charcoal p-8 md:p-12 rounded-sm max-w-2xl mx-auto shadow-2xl" data-id="element-126">
            <p className="text-sm uppercase tracking-widest text-brand-gold font-bold mb-4" data-id="element-127">
              Inversión Única
            </p>

            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-128">
              <span className="text-2xl md:text-3xl text-brand-charcoal/40 line-through font-serif" data-id="element-129">
                $19.99
              </span>
              <span className="bg-green-500 text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-130">
                68% OFF
              </span>
            </div>

            <div className="text-6xl md:text-7xl font-bold font-serif mb-8 text-green-500" data-id="element-131">
              $6.39{' '}
              <span className="text-2xl text-brand-charcoal/50 font-sans" data-id="element-132">
                USD
              </span>
            </div>

            <Button href="https://creceyatrae.com/cart/45530524451007:1" className="w-full py-5 text-lg mb-6" data-id="element-133">
              Quiero mi agenda de 6 figuras ahora
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-brand-charcoal/60 font-medium" data-id="element-134">
              <div className="flex items-center gap-2" data-id="element-135">
                <Zap className="w-4 h-4 text-brand-gold" data-id="element-136" />
                Acceso inmediato tras la compra
              </div>
              <div className="flex items-center gap-2" data-id="element-137">
                <Lock className="w-4 h-4 text-brand-gold" data-id="element-138" />
                Pago seguro y cifrado
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}